module.exports = __webpack_public_path__ + "static/img/darwin.637f542.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/darwin.svg
// module id = 0Pfx
// module chunks = 1